/** Chiffres issus exclusivement du catalogue public, partagés entre SSR et navigateur. */
export type CatalogStats = { total: number; rounded: number; exact: string; round: string; label: string };
export function catalogStats(total: number): CatalogStats {
  const rounded = Math.floor(total / 100) * 100;
  const format = (n: number) => n.toLocaleString("fr-FR").replace(/[\u00a0\u202f]/g, " ");
  return { total, rounded, exact: format(total), round: format(rounded), label: `${format(rounded)}+` };
}
let readStats: () => CatalogStats | undefined = () => undefined;
export function installCatalogStatsReader(reader: () => CatalogStats | undefined) { readStats = reader; }
export function installBrowserCatalogStats(stats: CatalogStats) { installCatalogStatsReader(() => stats); }
export function getCatalogStats() { return readStats() ?? catalogStats(0); }

/** Nombre d'archives de presse référencées. */
export const PRESS_ARCHIVE_LABEL = "9 200";
